//
// KD在庫管理システム[375]持ち出し画面本体（サーバー対応）
//
// InventoryApp.js
//


import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import '../styles/InventoryApp.css';

import HistoryViewerModal from './HistoryViewerModal';
import ItemHistoryModal from './ItemHistoryModal';
import AdminLoginLogModal from './AdminLoginLogModal';
import CheckoutHistoryExportModal from './CheckoutHistoryExportModal';
import ImagePickerModal from './ImagePickerModal';
import DoubleConfirmModal from './doubleConfirmModal';
import ExcelInOutModal from './ExcelInOutModal';
import UserListEditModal from './userListEditModal';


const InventoryApp = ({ user, onLogout }) => {
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [tabMode, setTabMode] = useState('shelf'); // カテゴリと棚番号の切り替え
  const [activeCategory, setActiveCategory] = useState('すべて');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [viewerTargetUser, setViewerTargetUser] = useState(null); // 個人対象
  const [viewerTargetItem, setViewerTargetItem] = useState(null); // アイテム対象
  const [showLogModal, setShowLogModal] = useState(false);// 偽装ログイン履歴表示
  const [showExcelInOutModal, setShowExcelInOutModal] = useState(false); // 在庫一覧excel入出力
  const [showExportModal, setShowExportModal] = useState(false); // 持ち出し履歴エクセル出力
  const [showImagePicker, setShowImagePicker] = useState(false); // 編集時画像表示
  const [showUserListEditModal, setShowUserListEditModal] = useState(false); //ユーザーリスト編集
  const [clock, setClock] = useState('');
  const [filterMode, setFilterMode] = useState('all'); // 'all' or 'reorder'
  const [modalConfig, setModalConfig] = useState(null);
  const navigate = useNavigate();
  const pressTimerRef = useRef(null);
  const movedRef = useRef(false);

  // ファイル名の日付用関数 -----------------------------------------------------------
  
  function getTodayJST() {
    const now = new Date();
    now.setHours(now.getUTCHours() + 9); // UTCに直してから+9h
    return now.toISOString().split("T")[0];
  }

  // アイテムリスト追加時スクロール ---------------------------------------------------

  const checkoutPanelRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (checkoutPanelRef.current) {
        checkoutPanelRef.current.scrollTop = checkoutPanelRef.current.scrollHeight;
      }
    }, 100); // ← 100msだけ遅らせて確実に発火！
  }, [selectedItems]);

  // 履歴表示用（サーバーから取得）-----------------------------------
  const getUserHistory = async () => {
    try {
      const res = await fetch("https://newells4610.stars.ne.jp/data/checkoutrecords.json", {
        cache: "no-store" // ← キャッシュ無効化
      });
      const allLogs = await res.json();

      // 自分の履歴だけ抽出
      return allLogs
        .filter(log => log.userId === user.userId || log.user === user.name)
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    } catch (err) {
      console.error("履歴データの取得に失敗しました", err);
      return []; // エラー時は空配列を返す
    }
  };

  // 時計用 useEffect -----------------------------------------------------
  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const dayNames = ['日', '月', '火', '水', '木', '金', '土'];
      const formatted = `${now.getFullYear()}/${(now.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${now
        .getDate()
        .toString()
        .padStart(2, '0')}（${dayNames[now.getDay()]}） ${now
        .getHours()
        .toString()
        .padStart(2, '0')}:${now
        .getMinutes()
        .toString()
        .padStart(2, '0')}:${now
        .getSeconds()
        .toString()
        .padStart(2, '0')}`;
      setClock(formatted);
    };

    updateClock(); // 初回呼び出し
    const timer = setInterval(updateClock, 1000); // 毎秒更新

    return () => clearInterval(timer);
  }, []);

// 在庫データ読み込み ----------------------------------------------------------------------

  useEffect(() => {
    
    fetch("https://newells4610.stars.ne.jp/data/KDinventoryData.json?" + Date.now())
      .then(res => res.json())
      .then(setItems)
      .catch(err => {
        console.error("在庫データ取得失敗:", err);
        setModalConfig({
          message: "在庫データを取得できませんでした。\nネット接続をご確認ください。",
          onConfirm: () => setModalConfig(null),
        });
      });

  }, []);

// 在庫データ再読み込み --------------------------------------------------------------------

  const fetchInventoryFromServer = async () => {
    try {
      const res = await fetch("https://newells4610.stars.ne.jp/data/KDinventoryData.json?ts=${Date.now()}", {
        cache: "no-store"
      });
      const data = await res.json();
      setItems(data);
      
      setModalConfig({
        message: "✨✨在庫データを最新に更新しました！✨✨",
        onConfirm: () => setModalConfig(null),
      });

    } catch (err) {
      console.error("在庫データの再取得に失敗しました", err);
      
      setModalConfig({
        message: "在庫データの更新に失敗しました…😢",
        onConfirm: () => setModalConfig(null),
      });
    }
  };

// --------------------------------------------------------------------------------------

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 1); // アドレスバーを少し押し上げる
    }, 100); // 少し待ってから動かすと効果出やすい
  }, []);

// -----------------------------------------------------------------------------------

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const filePath = `images/${file.name}`;

    setEditingItem(prev => ({
      ...prev,
      image: filePath  // ← これだけ！Base64なし！
    }));
  };

  const shelves = [...new Set(items.map(item => item.shelf).filter(Boolean))].sort();
  const categories = [...new Set(items.map(item => item.category).filter(Boolean))].sort();

// ------------------------------------------------------------------------------------------

  const filteredItems =
    (tabMode === 'reorder'
      ? items.filter(item => parseFloat(item.stok) <= parseFloat(item.reorderThreshold))
      : activeCategory === 'すべて'
        ? items
        : tabMode === 'category'
          ? items.filter(item => item.category === activeCategory)
          : items.filter(item => item.shelf === activeCategory)
    ).sort((a, b) => (a.productId || '').localeCompare(b.productId || ''));
  
// -------------------------------------------------------------------------------------------

  const handleAddItem = (item) => {

  // 在庫が0以下なら追加しない
    if (parseFloat(item.stok) <= 0) {
      setModalConfig({
        message: `${item.name} \nは在庫がありません！😟`,
        onConfirm: () => setModalConfig(null),
      });
      return;
    }

  // 在庫が足りないのに持ち出し追加は無理よ
    const existing = selectedItems.find(i => i.id === item.id);
    const currentQty = existing ? existing.quantity : 0;

    if (currentQty + 1 > parseFloat(item.stok)) {
      setModalConfig({
        message: `${item.name} \nの在庫を超えて追加できません！😡`,
        onConfirm: () => setModalConfig(null),
      });
      return;
    }

    if (existing) {
      setSelectedItems(selectedItems.map(i =>
        i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
      ));
    } else {
      setSelectedItems([...selectedItems, { ...item, quantity: 1 }]);
    }
  };

// 新規追加の初期設定 ----------------------------
  const originalIdRef = useRef();

  const handleAddNew = () => {
    const maxId = items.reduce((max, item) => Math.max(max, Number(item.id || 0)), 0);
    const newItem = {
      id: maxId + 1,
      name: "",
      productId: "",
      stok: 0,
      unit: "個",
      shelf: "",
      shelfLevel: "",
      category: "",
      memo: "",
      oldShelfNumber: "",
      image: "",
      quantityPerBox: "",
      reorderThreshold: 5,
      maxCapacity: 1000,
      wholesaler: ""
    };
    setEditingItem(newItem);
    originalIdRef.current = undefined;
  };

// 持ち出し処理 -----------------------------------------------------------------
  const handleConfirmCheckout = () => {
    if (!user || !user.userId?.trim()) {
      setModalConfig({
        message: "ログインしてください。😡",
        onConfirm: () => setModalConfig(null),
      });
      return;
    };

    if (selectedItems.length === 0) {
      setModalConfig({
        message: "持ち出しリストが空です。🙄",
        onConfirm: () => setModalConfig(null),
      });
      return;
    };

  // モーダルで再確認へ
    setShowConfirmModal(true);
  };

// 小数点も受け入れるように ---------------------------------------------------------
  const handleEdit = (item) => {
    if (user?.isAdmin) {
      setEditingItem({
        ...item,
        stok: parseFloat(item.stok) || 0
      });
      originalIdRef.current = item.id; // ← ここも大事っ！
    }
  };


// アイテム編集後の保存処理 -------------------------------------------------------------


  const proceedWithSave = async () => {

    // サーバー送信処理
    try {
      const res = await fetch("https://newells4610.stars.ne.jp/api/update_item.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editingItem)
      });
      const json = await res.json();

      if (!res.ok || json.status !== "ok") {
        throw new Error(json.message || "サーバー保存に失敗しました😖💦");
      }

      setItems(json.updatedInventory);
      setEditingItem(null);

      setModalConfig({
        message: "在庫データを保存しました。✌",
        onConfirm: () => setModalConfig(null),
      });

    } catch (err) {
      setModalConfig({
        message: `保存エラー: ${err.message}`,
        onConfirm: () => setModalConfig(null),
      });
    }

  };

  const handleSaveEdit = async () => {
    const enteredId = editingItem.id;

    // IDが他の商品と被ってないか（自分自身は除く）
    const conflict = items.find(
      (item) => item.id === enteredId && item.id !== originalIdRef.current
    );

    if (conflict) {
      setModalConfig({
        message: `その番号（ID: ${enteredId}）は既に登録されています！😯`,
        onConfirm: () => setModalConfig(null),
      });
      return; // 保存キャンセル
    }

    // 既存アイテムで ID が変更されている場合
    if (
      originalIdRef.current !== undefined &&
      originalIdRef.current !== enteredId
    ) {
      setModalConfig({
        message: `IDが「${originalIdRef.current}」から「${enteredId}」に変更されています。\nよろしいですか？`,
        showCancel: true,
        onConfirm: () => {
          setModalConfig(null);
          proceedWithSave();
        },
        onCancel: () => setModalConfig(null),
      });
      return; // モーダル表示後、処理を一時中断
    }

  // ID変更がない場合でも proceedWithSave 実行！
    proceedWithSave();

  };

// ----------------------------------------------------------------------

  const handleChange = (field, value) => {
    setEditingItem({ ...editingItem, [field]: value });
  };

  const updateQuantity = (item, delta) => {
    setSelectedItems(prev =>
      prev.map(i =>
        i.id === item.id
          ? { ...i, quantity: Math.max(i.quantity + delta, 1) }
          : i
      )
    );
  };

  const removeItem = (item) => {
    setSelectedItems(prev => prev.filter(i => i.id !== item.id));
  };

// ------ モバイルで長押し（ロングタップ）したか？の判定 ----------------

const handleTouchStart = (item) => {
  if (!user?.isAdmin) return;

  movedRef.current = false;

  pressTimerRef.current = setTimeout(() => {
    if (!movedRef.current) {
      handleEdit(item);
    }
  }, 5000); // ← ロングタップ時間
};

const handleTouchEnd = () => {
  clearTimeout(pressTimerRef.current);
};

const handleTouchMove = () => {
  movedRef.current = true;
  clearTimeout(pressTimerRef.current);
};

// --------------------------------------------------------------------

const changeQuantity = (item, delta) => {
  const updated = selectedItems.map(i => {
    if (i.id === item.id) {
      const newQty = i.quantity + delta;
      if (newQty > parseFloat(i.stok)) {
        setModalConfig({
          message: `🚫${i.name} \nの在庫を超えて追加できません！`,
          onConfirm: () => setModalConfig(null),
        });
        return i; // そのまま変えない
      }
      return { ...i, quantity: Math.max(1, newQty) };
    }
    return i;
  });

  setSelectedItems(updated);
};

// ---------------------------------------------------------------------

const updateQuantityDirect = (item, newQuantity) => {
  const parsed = parseFloat(newQuantity);
  if (isNaN(parsed)) return;

  const stock = parseFloat(item.stok);
  if (parsed > stock) {
    setModalConfig({
      message: `🚫${item.name} \nの在庫を超える数量は入力できません！`,
      onConfirm: () => setModalConfig(null),
    });
    return;
  }

  setSelectedItems(prev =>
    prev.map(i =>
      i.id === item.id
        ? { ...i, quantity: Math.max(0.01, parsed) }
        : i
    )
  );
};




// ----- 画面 -------------------------------------------------------------------------

  return (
    <>
      {/* 🚨 縦向き警告メッセージ */}
      <div className="rotate-warning" style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#fff',
        zIndex: 9999,
        display: 'none',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1.5rem',
        textAlign: 'center',
        padding: '20px'
      }}>
        📱このアプリは横向き専用です<br />
        端末を横にしてご利用ください
      </div>

{/* 在庫管理メイン ----------------------------------------------------- */}

      <div className="inventory-app">
        <div className="header">
          <h2
            className="title-heading"
            onClick={fetchInventoryFromServer}
            style={{ cursor: 'pointer' }}
          >
            KD在庫管理[375]
            {user?.isAdmin && (
              <span className="admin-mode-label">管理mode</span>
            )}
          </h2>
           
          <div className="user-display">
            お疲れさまです！ {user?.company ? `${user.company}・` : ''}{user?.name || user?.userId} さん
  	      </div>
          <div className="clock-display">{clock}</div>
        </div>

        <div className="tab-switcher">

          <button
            onClick={() => {
              setTabMode('shelf');
              setActiveCategory('すべて');
              setFilterMode('all');
            }}
            className={tabMode === 'shelf' && filterMode === 'all' ? 'active' : ''}
          >
            棚番 別
          </button>

          <button
            onClick={() => {
              setTabMode('category');
              setActiveCategory('すべて');
              setFilterMode('all');
            }}
            className={tabMode === 'category' && filterMode === 'all' ? 'active' : ''}
          >
            カテゴリ別
          </button>

          <button
            onClick={() => setTabMode('reorder')}
            className={tabMode === 'reorder' ? 'active reorder' : 'reorder'}
          >
            ⚠ 発注対象
          </button>

          {user?.isAdmin && (
            <button
              onClick={() => navigate("/order")}
              className="admin-button"
              title="発注依頼画面へ"
            >
              発注依頼画面へ
            </button>
          )}

          <button onClick={()=>setViewerTargetUser(user.userId)}
            className="tab-button history-button"
          >
            持出し履歴
          </button>
          
          <button
            onClick={() => {
              setModalConfig({
                message: "ログアウトしますか？",
                showCancel: true,
                onConfirm: () => {
                  setModalConfig(null);

                  // サーバー側セッション削除
                  fetch("https://newells4610.stars.ne.jp/api/logout.php", { method: "POST" })
                    .then(res => res.json())
                    .then(data => {
                      console.log("サーバーログアウト:", data);
                    })
                    .catch(err => {
                      console.error("サーバーログアウトエラー:", err);
                    })
                    .finally(() => {

                      // フロント側もクリア
                      localStorage.removeItem("user");
                      window.location.reload();
                    });

                },
                onCancel: () => setModalConfig(null),
              });
            }}
            className="tab-button logout-button"
          >
            ログアウト
          </button>
          
        </div>

          <div className="category-tabs">
            {tabMode === 'reorder' ? (
              <div className="reorder-message" style={{ padding: '3px', color: 'red' }}>
                ⚠  在庫が少なくなっている商品です。持ち出し過ぎには気を付けてください。
              </div>
            ) : (
              <>
                {user?.isAdmin && (
                  <div className="admin-controls">
                    <button onClick={handleAddNew}>＋ 新規追加</button>
                  </div>
                )}

                {(tabMode === 'category' ? categories : shelves).map(value => (
                  <button
                    key={value}
                    className={activeCategory === value ? 'active' : ''}
                    onClick={() => setActiveCategory(value)}
                  >
                    {value}
                  </button>
                ))}
              </>
            )}
          </div>

  {/* ---- 左パネル：アイテム一覧 ------------------------------------ */}

        <div className="main-content">
          <div className="item-list">
            {filteredItems.map(item => (
            <div
              key={`${item.id}-${item.stock}`}
              className="item-card"

              // 左クリック(PCマウス操作) or タップ(モバイル)
              onClick={() => {
                if (user?.isAdmin) {
                  // 管理mode：アイテム履歴表示へ
                  setViewerTargetItem(item);    // ← itemオブジェクト全体を履歴コンポーネントに渡す
                } else {
                  handleAddItem(item);         // 一般ユーザー：持ち出しリスト
                }
              }}

              onTouchStart={() => handleTouchStart(item)}  // 管理者のみ編集
              onTouchEnd={handleTouchEnd}
              onTouchMove={handleTouchMove}

              // 右クリック(PCマウス操作)
              onContextMenu={(e) => {
                e.preventDefault(); // ← デフォルトの右クリックメニューを抑制
                if (user?.isAdmin) {
                  handleEdit(item); // ← 編集モーダル起動！
                }
              }}

            >
                <img src={item.image || "/images/NoImage.jpg"} alt={item.name} width="80" />
                  <div className="item-info">
                    <strong className="item-name" style={{ whiteSpace: 'pre-wrap' }}>
                      {item.name}
                    </strong>

                    <p className="item-id">品番: {item.productId}</p>

                    {user?.isAdmin && (
                      <p
                        className="item-stock"
                        style={{
                          color:
                            parseFloat(item.stok) <= parseFloat(item.reorderThreshold || 0)
                              ? 'red'
                              : 'inherit',
                        }}
                      >
                        在庫：
                        <span className={parseFloat(item.stok) <= 0 ? 'out-of-stock' : ''}>
                          {Number(item.stok ?? 0).toFixed(2)} {item.unit || ''}
                        </span>
                      </p>
                    )}

                    <p className="memo">・{item.memo}</p>
                  </div>
              </div>
            ))}
          </div>

{/* ---------- 右パネル ---------- */}

          <div className="checkout-panel">
            {user?.isAdmin ? (
              <>
                {user.role === "管理者" ? (
                  <>
                    {/* 管理モードで[管理者]の時はボタン群を配置 */}
                    <p></p>
                    <div className="admin-panel-buttons">
                      
                      {/* 受け払い表2.0(コピペ用)Excel出力 */}
                      <button
                        onClick={() => {
                          fetch("https://newells4610.stars.ne.jp/api/export_excel_uke2lite.php", {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({ items: items }),
                          })
                            .then((res) => {
                              if (!res.ok) throw new Error("出力に失敗しました");
                              return res.blob();
                            })
                            .then((blob) => {
                              const url = window.URL.createObjectURL(blob);
                              const a = document.createElement("a");
                              a.href = url;
                              a.download = `受払表Ver2.0Lite(コピペ用)_${getTodayJST()}.xlsx`;
                              document.body.appendChild(a);
                              a.click();
                              a.remove();
                              window.URL.revokeObjectURL(url);
                            })
                            .catch((err) => {
                              setModalConfig({ message: "エクセル出力失敗: " + err.message, onConfirm: () => setModalConfig(null) });
                            });
                        }}
                        className="admin-button"
                        title="受け払い表2.0向けコピペ用excelファイルを出力します"
                      >
                        受け払い表2.0コピペExcel出力
                      </button>

                      {/* 在庫Excel入出力（モーダルを開く） */}
                      <button onClick={() => setShowExcelInOutModal(true)} className="admin-button">
                        在庫一覧表 Excel 入力・出力
                      </button>

                      {/* 全持出し履歴表示出力（モーダルを開く） */}
                      <button onClick={() => setShowExportModal(true)} className="admin-button">
                        全持出し履歴 表示・出力
                      </button>

                      {/* 全偽装ログイン履歴（モーダルを開く） */}
                      <button onClick={() => setShowLogModal(true)} className="admin-button">
                        全偽装ログイン履歴 表示出力
                      </button>

                      {/* UserList編集（管理者で ID=KDU93103001000 のみ表示） */}
                      {user?.userId === "KDU93103001000" && (
                        <button onClick={() => setShowUserListEditModal(true)} className="admin-button">
                          ユーザーリスト編集
                        </button>
                      )}

                    </div>
                  </>
                     
                ) : user.role === "発注のみ" ? (
                  
                  <>
                    {/* 管理モードでも[発注のみ]の時は全偽装ログイン履歴ボタンのみ表示 */}
                    <p></p>
                    <div className="admin-panel-buttons">
                      {/* 全偽装ログイン履歴（モーダルを開く） */}
                {/*    <button onClick={() => setShowLogModal(true)} className="admin-button">
                        全偽装ログイン履歴 表示出力
                      </button>  */}
                    </div>
                  </>
                  
                ) : null}
                 
              </>
              
            ) : (
              
              <>
                {/* 利用者モードの時は、持ち出しリスト */}
                <h3>📋持ち出しリスト</h3>
                <p style={{ color: "red", fontSize: "12px", marginTop: "-4px", marginLeft: "10px" }}>
                  持ち出し単位に気を付けてください！<br />小数点下2桁まで正確にお願いします！
                </p>
                <div className="checkout-panel-scroll" ref={checkoutPanelRef}>
                  {selectedItems.map((item) => (
                    <div key={item.id} className="checkout-item">
                      <div className="checkout-name">{item.name}</div>
                      <div className="checkout-controls">
                        <button onClick={() => changeQuantity(item, -1)}>-</button>
                        <input
                          type="number"
                          min="0.01"
                          step="0.01"
                          value={item.quantity}
                          onChange={(e) => updateQuantityDirect(item, e.target.value)}
                        />
                        <span className="item-unit">{item.unit || "個"}</span>
                        <button onClick={() => changeQuantity(item, 1)}>+</button>
                        <button onClick={() => removeItem(item)}>🗑</button>
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  className="checkout-confirm-button"
                  onClick={handleConfirmCheckout}
                >
                  ✔ 確定
                </button>
              </>
              
            )}
          </div>

        </div>


{/* 編集モーダル ---------------------------------------------------------------- */}

        {editingItem && (
          <div className="edit-modal">
            <div className="edit-box">
        	
              <label>
                管理ID（変更注意）：
               <input
                 type="number"
                 value={editingItem.id}
                 onChange={(e) =>
                   setEditingItem({ ...editingItem, id: Number(e.target.value) })
                 }
               />
              </label>

              <label>
                商品名：
                <textarea
                  rows="2"
                  value={editingItem.name}
                  onChange={e => handleChange('name', e.target.value)}
                />
              </label>

              <label>
                品番：
                <input type="text" value={editingItem.productId} onChange={e => handleChange('productId', e.target.value)} />
              </label>

              <label>
                在庫数：
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={editingItem.stok}
                  onChange={e => handleChange('stok', parseFloat(e.target.value) || 0)}
                />
              </label>

              <label>
                単位：
                <input type="text" value={editingItem.unit} onChange={e => handleChange('unit', e.target.value)} />
              </label>

              <label>
                入り数：
                <input type="text" value={editingItem.quantityPerBox || ''} onChange={e => handleChange('quantityPerBox', e.target.value)} />
              </label>

              <label>
                発注必要在庫数：
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={editingItem.reorderThreshold || ''}
                  onChange={e => handleChange('reorderThreshold', parseFloat(e.target.value) || 0)}
                />
              </label>

              <label>
                最大収納数：
                <input
                  type="text"
                  value={editingItem.maxCapacity || ''}
                  onChange={e => handleChange('maxCapacity', e.target.value)}
                />
              </label>

              <label>
                問屋名：
                <input type="text" value={editingItem.wholesaler} onChange={e => handleChange('wholesaler', e.target.value)} />
              </label>

              <label>
                旧棚番号：
                <input type="text" value={editingItem.oldShelfNumber} onChange={e => handleChange('oldShelfNumber', e.target.value)} />
              </label>

              <label>
                棚番号：
                <input
                  list="shelf-options"
                  value={editingItem.shelf || ''}
                  onChange={e => handleChange('shelf', e.target.value)}
                />
                <datalist id="shelf-options">
                 {Array.from(new Set(items
                   .map(item => item.shelf)
                   .filter(Boolean))) // ← ここで空データ除去！
                   .map((shelf, index) => (
                     <option key={index} value={shelf} />
                   ))}
               </datalist>
              </label>

              <label>
                段数：
                <input type="text" value={editingItem.shelfLevel} onChange={e => handleChange('shelfLevel', e.target.value)} />
              </label>

              <label>
                画像ファイル:
                <div style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
                  <button type="button" onClick={() => setShowImagePicker(true)}>画像を選ぶ</button>
                  {editingItem.image && (
                    <img src={editingItem.image} alt="選択画像" width="80" />
                  )}
                </div>

                {/* 保存されたファイルパスを表示（読み取り専用） */}
                {editingItem.image && (
                  <input
                    type="text"
                    value={editingItem.image}
                    readOnly
                    style={{
                      marginTop: '4px',
                      fontSize: '12px',
                      backgroundColor: '#f0f0f0',
                      border: '1px solid #ccc'
                    }}
                  />
                )}
              </label>

              <label>
                カテゴリ：
                <input
                  list="category-options"
                  value={editingItem.category}
                  onChange={e => handleChange('category', e.target.value)}
                />
                <datalist id="category-options">
                  {Array.from(new Set(items.map(item => item.category))).map((cat, index) => (
                    <option key={index} value={cat} />
                  ))}
                </datalist>
              </label>

              <label>
                メモ：
                <input type="text" value={editingItem.memo} onChange={e => handleChange('memo', e.target.value)} />
              </label>

              {/* 削除ボタン */}
              {user?.isAdmin && (
                <div style={{ marginTop: '12px', display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => {
                      setModalConfig({
                        message: "⚠このアイテムを削除しますか？",
                        showCancel: true,
                        onConfirm: async () => {
                          setModalConfig(null);
                          try {
                            const res = await fetch("https://newells4610.stars.ne.jp/api/delete_item.php", {
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify({ id: editingItem.id })
                            });
                            const json = await res.json();

                            if (!res.ok || json.status !== "ok") {
                              throw new Error(json.message || "削除失敗");
                            }

                            setItems(json.updatedInventory);
                            setEditingItem(null);

                            setModalConfig({
                              message: "削除しました！",
                              onConfirm: () => setModalConfig(null),
                            });
                          } catch (err) {
                            setModalConfig({
                              message: `削除エラー: ${err.message}`,
                              onConfirm: () => setModalConfig(null),
                            });
                          }
                        },
                        onCancel: () => setModalConfig(null),
                      });
                    }}
                  >
                    削除
                  </button>

                  <button onClick={() => setEditingItem(null)}>
                    キャンセル
                  </button>

                  <button onClick={handleSaveEdit}>
                    保存
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* 持ち出しリスト、最終確認モーダル */}
      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>この内容で持ち出しを確定しますか？</h3>
            <div className="modal-list">
              {selectedItems.map((item) => (
                <div key={item.id} className="modal-item">
                  {item.name}（品番: {item.productId}）× {item.quantity}
                </div>
              ))}
            </div>
            <div className="modal-actions">
              <button


                onClick={async () => {
                  if (!user?.userId) {
                    setModalConfig({
                      message: "ログイン情報がありません！",
                      onConfirm: () => setModalConfig(null),
                    });
                    return;
                  }

                  const newRecord = {
                    timestamp: new Date().toISOString(),
                    user: user.userId || user.name || "不明ユーザー",
                    items: selectedItems.map(({ id, name, productId, stok, quantity, unit, shelf, shelfLevel, category, memo, oldShelfNumber, reorderThreshold }) => ({
                      id, name, productId, stok, quantity, unit, shelf, shelfLevel, category, memo, oldShelfNumber, reorderThreshold
                    })),
                  };

                  try {
                    // 🔸 JSONデータ（在庫）更新
                    const res = await fetch("https://newells4610.stars.ne.jp/api/update_stock.php", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(newRecord),
                    });
                    const json = await res.json();

                    if (!res.ok || json.status !== "ok") {
                      throw new Error(json.message || "在庫更新失敗");
                    }

                    await fetch("https://newells4610.stars.ne.jp/api/update_excel_uke2lite_stock.php", {
                      method: "POST",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(newRecord),
                    });

                    setItems(json.updatedInventory);
                    setSelectedItems([]);
                    setShowConfirmModal(false);
                    setModalConfig({
                      message: `${user.name || user.userId} さんの持ち出しを確定しました！`,
                      onConfirm: () => setModalConfig(null),
                    });

                  } catch (err) {
                    setModalConfig({
                      message: "サーバーへの持ち出し登録に失敗しました：" + err.message,
                      onConfirm: () => setModalConfig(null),
                    });
                  }
                }}


              >
                ✅ 確定
              </button>
              <button onClick={() => setShowConfirmModal(false)}>❌ キャンセル</button>
            </div>
          </div>
        </div>
      )}



    {/* 持ち出し履歴表示・個人が何を持ち出したか */}
      {viewerTargetUser && (
        <HistoryViewerModal
           userId={viewerTargetUser}   // ← user.id を渡す
           onClose={()=>setViewerTargetUser(null)}
        />
      )}

    {/* 持ち出し履歴表示・このアイテムを誰が持ち出したか */}
      {viewerTargetItem && (
        <ItemHistoryModal
          itemId={viewerTargetItem.id}     // ← item.id を渡す
          itemName={viewerTargetItem.name} // ← item.name を渡す
          onClose={() => setViewerTargetItem(null)}
        />
      )}

    {/* 持ち出し履歴エクセル出力 */}
      {showExportModal && (
        <div className="modal-overlay">
          <CheckoutHistoryExportModal onClose={() => setShowExportModal(false)} />
        </div>
      )}

    {/* 在庫一覧エクセル入出力 */}
      {showExcelInOutModal && (
        <ExcelInOutModal
          isOpen={showExcelInOutModal}
          onClose={() => setShowExcelInOutModal(false)}
          fetchInventoryFromServer={fetchInventoryFromServer}
        />
      )}

    {/* 偽装ログイン履歴表示 */}
      {showLogModal && (
        <div className="modal-overlay">
          <AdminLoginLogModal onClose={() => setShowLogModal(false)} />
        </div>
      )}

    {/* ユーザーリスト編集 */}
      {showUserListEditModal && (
        <UserListEditModal onClose={() => setShowUserListEditModal(false)} currentUser={user} />
      )}

    {/* 編集モーダルで画像選択 */}
      {showImagePicker && (
        <ImagePickerModal
          onSelect={(selectedImage) => {
            setEditingItem({ ...editingItem, image: selectedImage });
            setShowImagePicker(false);
          }}
          onClose={() => setShowImagePicker(false)}
        />
      )}
      
    {/* いろいろな場面で念押しウインドウ */}
      {modalConfig && <DoubleConfirmModal {...modalConfig} />}

    </>
  );
};

export default InventoryApp;
